/* ============================================================
   LILVAA — homepage interactions (vanilla JS, no dependencies)
   ============================================================ */
(() => {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const px = (id, w) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

  /* ---------- DATA ---------- */
  const products = [
    { name:'Sunset Glow Body Oil',        price:17.77, was:22.90, img:6801176, badge:'Bestseller' },
    { name:'Breeze Hair Elixir',          price:21.17, was:23.90, img:7006152, badge:'' },
    { name:'Healing Haven Soap',          price:9.27,  was:10.90, img:7055158, badge:'' },
    { name:'Mystique Meadow Hair Elixir', price:22.87, was:null,  img:7814941, badge:'New' },
    { name:'Amber Organic Soap',          price:9.27,  was:null,  img:3735152, badge:'' },
    { name:'Ruby Reverie Lip Balm',       price:16.07, was:null,  img:5240620, badge:'' },
    { name:'Bentonite Harmony Clay Mask', price:24.57, was:null,  img:8101530, badge:'New' },
    { name:'Silk Therapy Lip Mask',       price:21.17, was:null,  img:4735904, badge:'' },
  ];

  const bundles = [
    { name:'Botanical Bliss', sub:'Bundle of 5', price:74.97, was:91.20, img:5632335 },
    { name:'Tropical Escape', sub:'Bundle of 5', price:74.97, was:91.20, img:5632333 },
    { name:'Walk in Garden',  sub:'Bundle of 5', price:74.97, was:91.20, img:10155373 },
    { name:'Cozy Ritual',     sub:'Bundle of 5', price:74.97, was:91.20, img:6621470 },
  ];

  const reviews = [
    { q:'My evening routine finally feels like a luxury — the body oil sinks in and leaves the softest glow.', n:'Alina R.', av:762020 },
    { q:'Lightweight, plant-based and my frizz is just… gone. Healthy shine after a couple of weeks.', n:'Priya M.', av:1239291 },
    { q:'Not sticky, keeps my lips soft all day, and the subtle tint is gorgeous. Repurchasing forever.', n:'Tetiana K.', av:733872 },
    { q:'The coffee aroma turns it into a whole ritual. My lips have never felt smoother.', n:'Sam D.', av:220453 },
    { q:'Calmed my dry, itchy scalp and my hair actually looks thicker. Can’t recommend enough.', n:'Noor H.', av:1130626 },
    { q:'Clean, gentle, and you can tell it’s handmade. The packaging is beautiful too.', n:'Élise B.', av:774909 },
    { q:'Healing Haven Soap cleared up my eczema flare-ups. My whole family uses it now.', n:'Marcus T.', av:2379004 },
    { q:'The gift box was such a hit — beautiful, thoughtful, and everything actually works.', n:'Jen W.', av:712513 },
  ];

  const reel = [
    { vid:'7597242/7597242-hd_720_1280_24fps', name:'Sunset Glow Body Oil',  price:'$17.77', img:6801176 },
    { vid:'6975271/6975271-sd_338_640_30fps',  name:'Breeze Hair Elixir',    price:'$21.17', img:7006152 },
    { vid:'5937385/5937385-sd_360_640_24fps',  name:'Mystique Meadow Elixir',price:'$22.87', img:7814941, soldout:true },
    { vid:'7198952/7198952-sd_360_640_25fps',  name:'Amber Organic Soap',    price:'$9.27',  img:3735152 },
    { vid:'6445996/6445996-sd_360_640_25fps',  name:'Ruby Reverie Lip Balm', price:'$16.07', img:5240620 },
    { vid:'8995586/8995586-sd_360_640_25fps',  name:'Healing Haven Soap',    price:'$9.27',  img:7055158 },
    { vid:'4351016/4351016-sd_360_640_30fps',  name:'Bentonite Clay Mask',   price:'$24.57', img:8101530 },
  ];

  const circle = [762020, 6801176, 1239291, 7055158, 1130626, 6621470, 733872, 8101530, 712513];

  const badges = [
    { label:'Natural',        icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 20C5 12 10 6 19 6c0 9-6 14-14 14Z"/><path d="M6 19C9 14 13 11 18 10"/></svg>` },
    { label:'Handcrafted',    icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V11m0-5.5a1.5 1.5 0 0 1 3 0V11m0-3a1.5 1.5 0 0 1 3 0V14c0 3.3-2.4 6-6 6-2.6 0-4.2-1.2-5.4-3.1L5 14a1.5 1.5 0 0 1 2.5-1.6L8 13"/></svg>` },
    { label:'Cruelty Free',   icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 11.5C8.5 9.5 8 7 8.8 5c1 .7 1.8 2.3 2 4.2M14.5 11.5c1-2 1.5-4.5.7-6.5-1 .7-1.8 2.3-2 4.2"/><circle cx="12" cy="15.5" r="4"/><path d="M10.6 15.2h.01M13.4 15.2h.01"/></svg>` },
    { label:'Made in Canada', icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21c4-4.6 6-7.8 6-10.5a6 6 0 1 0-12 0C6 13.2 8 16.4 12 21Z"/><circle cx="12" cy="10.5" r="2.2"/></svg>` },
    { label:'Paraben Free',   icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4c3 4 5 6.6 5 9a5 5 0 0 1-8.4 3.6M7.1 12C7 7.6 12 4 12 4"/><path d="M5 5l14 14"/></svg>` },
    { label:'Gender Neutral', icon:`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3"/><circle cx="16.5" cy="9" r="2.4"/><path d="M3.5 20c.5-3 2.7-4.6 5.5-4.6 1.5 0 2.8.5 3.8 1.4"/><path d="M14.6 15.6c1.8.3 3.3 1.8 3.7 4.4"/></svg>` },
  ];

  const money = (n) => '$' + n.toFixed(2) + ' CAD';

  /* ---------- render: best sellers ---------- */
  function renderProducts() {
    const track = $('#productTrack');
    if (!track || track.children.length) return;
    track.innerHTML = products.map(p => `
      <article class="pcard">
        <a class="pcard__media" href="#shop">
          ${p.badge ? `<span class="pcard__badge">${p.badge}</span>` : ''}
          <img src="${px(p.img,600)}" alt="${p.name}" loading="lazy" />
          <button class="pcard__add" data-add="${p.name}">Add to cart — ${money(p.price)}</button>
        </a>
        <div class="pcard__info">
          <h3 class="pcard__name">${p.name}</h3>
          <p class="pcard__price">${p.was ? `<del>${money(p.was)}</del>` : ''}<ins>${money(p.price)}+</ins></p>
        </div>
      </article>`).join('');
  }

  /* ---------- render: gift boxes ---------- */
  function renderBundles() {
    const track = $('#bundleTrack');
    if (!track || track.children.length) return;
    track.innerHTML = bundles.map(b => `
      <article class="pcard">
        <a class="pcard__media" href="#bundles">
          <span class="pcard__badge">Save ${money(b.was - b.price).replace(' CAD','')}</span>
          <img src="${px(b.img,640)}" alt="${b.name}" loading="lazy" />
          <button class="pcard__add" data-add="${b.name} Bundle">Add to cart — ${money(b.price)}</button>
        </a>
        <div class="pcard__info">
          <h3 class="pcard__name">${b.name} <span style="font-style:italic;color:var(--muted);font-size:.85em">| ${b.sub}</span></h3>
          <p class="pcard__price"><del>${money(b.was)}</del><ins>${money(b.price)}</ins></p>
        </div>
      </article>`).join('');
  }

  /* ---------- render: testimonials ---------- */
  function renderReviews() {
    const track = $('#reviewTrack');
    if (!track) return;
    track.innerHTML = reviews.map(r => `
      <article class="tcard">
        <img class="tcard__avatar" src="${px(r.av, 600)}" alt="${r.n}" loading="lazy" />
        <div class="tcard__stars" aria-label="5 out of 5 stars">★★★★★</div>
        <p class="tcard__quote">“${r.q}”</p>
        <p class="tcard__name">${r.n}</p>
      </article>`).join('');
  }

  /* ---------- render: shoppable reel ---------- */
  function renderReel() {
    const wrap = $('#reel');
    if (!wrap) return;
    wrap.innerHTML = reel.map(r => `
      <div class="vcard">
        <video src="https://videos.pexels.com/video-files/${r.vid}.mp4" autoplay muted loop playsinline preload="metadata"></video>
        <div class="vcard__grad"></div>
        <div class="vcard__foot">
          <div class="vcard__prod">
            <img class="vcard__thumb" src="${px(r.img,120)}" alt="" loading="lazy" />
            <span><b>${r.name}</b>${r.price}</span>
          </div>
          <div class="vcard__cart">
            <button ${r.soldout ? 'disabled' : `data-add="${r.name}"`}>${r.soldout ? 'Sold Out' : 'Add To Cart'}</button>
            <button aria-label="More options" ${r.soldout ? 'disabled' : `data-add="${r.name}"`}>▾</button>
          </div>
        </div>
      </div>`).join('');
  }

  /* ---------- render: Join Our Circle gallery ---------- */
  function renderCircle() {
    const track = $('#circleTrack');
    if (!track) return;
    track.innerHTML = circle.map(id => `
      <a class="gcard" href="#circle" aria-label="Community post">
        <img src="${px(id, 500)}" alt="" loading="lazy" />
        <svg class="gcard__ig" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
      </a>`).join('');
  }

  /* ---------- render: trust-badge strip ---------- */
  function renderRibbon() {
    const track = $('#ribbonTrack');
    if (!track) return;
    const set = badges.map(b => `<span class="ribbon__item">${b.icon}<span>${b.label}</span></span>`).join('');
    track.innerHTML = set + set;
  }

  /* ---------- testimonials: continuous auto-scroll marquee ---------- */
  function setupReviewMarquee() {
    const track = $('#reviewTrack');
    if (!track || !track.children.length) return;
    track.innerHTML += track.innerHTML;
    let setWidth = track.scrollWidth / 2;
    const measure = () => { setWidth = track.scrollWidth / 2 || setWidth; };
    addEventListener('load', measure);
    setTimeout(measure, 500);
    if (reduce) return;

    const speed = 100;
    let pos = 0, last = null, paused = false, dragging = false;
    let startX = 0, startPos = 0, moved = 0;

    const wrap = () => {
      if (!setWidth) return;
      while (pos <= -setWidth) pos += setWidth;
      while (pos > 0) pos -= setWidth;
    };

    const frame = (ts) => {
      if (last == null) last = ts;
      const dt = Math.min(0.05, (ts - last) / 1000); last = ts;
      if (!dragging && !paused) pos -= speed * dt;
      wrap();
      track.style.transform = `translateX(${pos}px)`;
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);

    const mq = track.parentElement;
    mq.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') paused = true; });
    mq.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') paused = false; });

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      dragging = true; startX = e.clientX; startPos = pos; moved = 0;
      track.classList.add('is-dragging');
    });
    addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      pos = startPos + dx; wrap();
    });
    const up = () => { if (dragging) { dragging = false; track.classList.remove('is-dragging'); } };
    addEventListener('pointerup', up);
    addEventListener('pointercancel', up);
    track.addEventListener('dragstart', (e) => e.preventDefault());
    track.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- shoppable reel: mouse drag-to-scroll ---------- */
  function setupReel() {
    const reelEl = $('#reel');
    if (!reelEl) return;
    let down = false, startX = 0, startLeft = 0, moved = 0;
    reelEl.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; startX = e.clientX; startLeft = reelEl.scrollLeft; moved = 0;
      reelEl.classList.add('is-dragging');
    });
    addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      reelEl.scrollLeft = startLeft - dx;
    });
    const up = () => { if (down) { down = false; reelEl.classList.remove('is-dragging'); } };
    addEventListener('pointerup', up);
    addEventListener('pointercancel', up);
    reelEl.addEventListener('click', (e) => {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- generic carousel ---------- */
  function setupCarousel(root) {
    const track = $('.carousel__track', root);
    const viewport = $('.carousel__viewport', root);
    const prev = $('[data-prev]', root);
    const next = $('[data-next]', root);
    if (!track || !track.children.length) return;

    let index = 0, step = 0, maxIndex = 0;

    const measure = () => {
      const first = track.children[0];
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const cardW = first.getBoundingClientRect().width;
      step = cardW + gap;
      const perView = Math.max(1, Math.round((viewport.clientWidth + gap) / step));
      maxIndex = Math.max(0, track.children.length - perView);
      index = Math.min(index, maxIndex);
      apply();
    };
    const apply = () => {
      track.style.transform = `translateX(${-index * step}px)`;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex;
    };
    const go = (i) => { index = Math.max(0, Math.min(i, maxIndex)); apply(); };

    next && next.addEventListener('click', () => go(index + 1));
    prev && prev.addEventListener('click', () => go(index - 1));

    let down = false, sx = 0, base = 0, moved = 0;
    const onDown = (e) => { down = true; sx = e.clientX; base = -index * step; moved = 0; track.classList.add('is-dragging'); track.setPointerCapture?.(e.pointerId); };
    const onMove = (e) => { if (!down) return; moved = e.clientX - sx; track.style.transform = `translateX(${base + moved}px)`; };
    const onUp = () => {
      if (!down) return; down = false; track.classList.remove('is-dragging');
      if (Math.abs(moved) > step * 0.18) go(index + (moved < 0 ? 1 : -1)); else apply();
    };
    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove);
    addEventListener('pointerup', onUp);
    track.addEventListener('dragstart', e => e.preventDefault());

    let rT; addEventListener('resize', () => { clearTimeout(rT); rT = setTimeout(measure, 150); });
    measure();
    addEventListener('load', measure);
    setTimeout(measure, 400);
  }

  /* ---------- proven results: before / after drag-to-compare ---------- */
  function setupBeforeAfter() {
    const ba = $('#provenBA');
    if (!ba) return;
    const handle = $('.ba__handle', ba);
    const setPct = (pct) => {
      pct = Math.max(0, Math.min(100, pct));
      ba.style.setProperty('--ba-pos', pct + '%');
      handle && handle.setAttribute('aria-valuenow', Math.round(pct));
    };
    const fromX = (x) => { const r = ba.getBoundingClientRect(); setPct(((x - r.left) / r.width) * 100); };
    let dragging = false;
    ba.addEventListener('pointerdown', (e) => { dragging = true; ba.setPointerCapture(e.pointerId); fromX(e.clientX); e.preventDefault(); });
    ba.addEventListener('pointermove', (e) => { if (dragging) fromX(e.clientX); });
    const stop = (e) => { dragging = false; try { ba.releasePointerCapture(e.pointerId); } catch (_) {} };
    ba.addEventListener('pointerup', stop);
    ba.addEventListener('pointercancel', stop);
    handle?.addEventListener('keydown', (e) => {
      const cur = parseFloat(ba.style.getPropertyValue('--ba-pos')) || 50;
      const k = e.key;
      if (k === 'ArrowLeft' || k === 'ArrowDown') { setPct(cur - 3); e.preventDefault(); }
      else if (k === 'ArrowRight' || k === 'ArrowUp') { setPct(cur + 3); e.preventDefault(); }
      else if (k === 'Home') { setPct(0); e.preventDefault(); }
      else if (k === 'End') { setPct(100); e.preventDefault(); }
    });
    setPct(50);
  }

  /* ---------- wavy text marquee ---------- */
  function setupWaveMarquee() {
    const path = $('#waveMqPath');
    const tp = $('#waveMqText');
    if (!path || !tp) return;

    const W = 4800, mid = 100, A = 56, P = 720;
    const half = P / 2, cx = half / 3, hy = A * 4 / 3;
    let d = 'M0,' + mid, x = 0, s = 1;
    while (x < W) {
      const cy = mid + s * hy;
      d += ' C' + (x + cx) + ',' + cy + ' ' + (x + half - cx) + ',' + cy + ' ' + (x + half) + ',' + mid;
      x += half; s = -s;
    }
    path.setAttribute('d', d);

    const phrase = 'you are beautifully unique. ';
    const reps = 20;
    tp.textContent = phrase.repeat(reps);

    const textEl = tp.closest('text');
    const animate = () => {
      const total = textEl.getComputedTextLength();
      if (!total) { requestAnimationFrame(animate); return; }
      if (reduce) { tp.setAttribute('startOffset', '0'); return; }
      const phraseLen = total / reps;
      const speed = 55;
      let start = null;
      const step = (ts) => {
        if (start === null) start = ts;
        const off = -(((ts - start) / 1000 * speed) % phraseLen);
        tp.setAttribute('startOffset', off.toFixed(2));
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    (document.fonts && document.fonts.ready) ? document.fonts.ready.then(animate) : animate();
  }

  /* ---------- header scroll state ---------- */
  function header() {
    const h = $('#header');
    if (!h) return;
    // Horizon makes .page-wrapper the scroll container at >=990px, so
    // window.scrollY never changes there. Track whichever one scrolls.
    const scroller = document.querySelector('.page-wrapper');
    const getY = () => (scroller ? scroller.scrollTop : 0) || window.scrollY || 0;
    const onScroll = () => h.classList.toggle('is-stuck', getY() > 12);
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  function drawer() {
    const d = $('#drawer'), burger = $('#burger');
    if (!d) return;
    const open = () => { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; };
    const close = () => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
    burger?.addEventListener('click', open);
    d.addEventListener('click', e => { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    const els = $$('[data-reveal]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
  }

  /* ---------- cart + toast ---------- */
    /* ---------- cart: real Shopify AJAX cart ---------- */
  function setCartCount(n) {
    var cc = $('#cartCount'); if (cc) cc.textContent = n;
    var btn = $('#cartBtn');
    if (btn && btn.animate) btn.animate([{ transform:'scale(1)' }, { transform:'scale(1.25)' }, { transform:'scale(1)' }], { duration:360, easing:'cubic-bezier(.22,.61,.36,1)' });
  }
  function showToast(msg) {
    var toast = $('#toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; })
      .catch(function () { return null; });
  }
  /* Keep the header badge in sync when Horizon's own product forms change the cart. */
  (function watchCartMutations() {
    var CART_RE = new RegExp('/cart/(add|change|update|clear)');
    if (window.fetch && !window.__lilvaaCartWatch) {
      window.__lilvaaCartWatch = true;
      var orig = window.fetch;
      window.fetch = function () {
        var url = '';
        try { url = (typeof arguments[0] === 'string') ? arguments[0] : ((arguments[0] && arguments[0].url) || ''); } catch (e) {}
        var p = orig.apply(this, arguments);
        if (CART_RE.test(url)) { p.then(function () { setTimeout(refreshCart, 150); }, function () {}); }
        return p;
      };
    }
    ['cart:update', 'cart-update', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { refreshCart(); });
    });
  })();
  function addToCart(name, variantId, btn) {
    if (!variantId) {
      showToast('\u201C' + name + '\u201D is coming soon \u2014 not available to order yet');
      return;
    }
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    var done = function () { if (btn) { btn.disabled = false; btn.textContent = label; } };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.d && res.d.description ? res.d.description : 'Sorry, that could not be added'); done(); return; }
        showToast('\uD83D\uDED2 Added \u201C' + name + '\u201D to your bag');
        done();
        return refreshCart();
      })
      .catch(function () { showToast('Sorry, something went wrong'); done(); });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      addToCart(add.dataset.add, add.dataset.variant, add);
    }
  });

  /* ---------- newsletter forms ---------- */
  function newsletter() {
    $$('#newsForm, #newsFormFoot, #popupForm').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const input = form.querySelector('input');
        if (!input.value || !input.checkValidity()) { input.focus(); return; }
        const ok = form.parentElement.querySelector('.news__ok');
        if (ok) ok.hidden = false;
        input.value = '';
        if (form.id === 'popupForm') closePopup();
      });
    });
  }

  /* ---------- Join Our Circle popup + fab ---------- */
  let popupSeen = false;
  const popup = $('#popup'), fab = $('#fab');
  function openPopup() { popup?.classList.add('is-open'); popup?.setAttribute('aria-hidden', 'false'); fab && (fab.hidden = true); }
  function closePopup() { popup?.classList.remove('is-open'); popup?.setAttribute('aria-hidden', 'true'); if (fab) fab.hidden = false; popupSeen = true; }
  function setupPopup() {
    if (!popup) return;
    popup.addEventListener('click', e => { if (e.target.closest('[data-popup-close]')) closePopup(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup(); });
    fab?.addEventListener('click', openPopup);
    if (!reduce) setTimeout(() => { if (!popupSeen) openPopup(); }, 5000);
  }

  /* ---------- init ---------- */
  function init() {
    $('#year') && ($('#year').textContent = new Date().getFullYear());
    renderProducts();
    renderBundles();
    renderReviews();
    renderReel();
    renderCircle();
    renderRibbon();
    $$('[data-carousel]').forEach(setupCarousel);
    setupReel();
    setupReviewMarquee();
    setupBeforeAfter();
    setupWaveMarquee();
    header();
    drawer();
    reveal();
    newsletter();
    setupPopup();
    refreshCart();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
